{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-520000",
  "sheetId": "StatementOfCashFlowsIndirectMethod",
  "label": "[520000] Statement of cash flows, indirect method (MFRS)",
  "description": "Statement of cash flows using indirect method reconciling profit to cash flows from operating activities (MFRS)",
  "taxonomy": "FS-MFRS",
  "controls": [
    {
      "qname": "ssmt-mfrs:StatementOfCashFlowsHeader",
      "label": "Statement of cash flows",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 1
      }
    },
    {
      "qname": "ifrs-full:CashFlowsFromUsedInOperatingActivitiesHeader",
      "label": "Cash flows from (used in) operating activities",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ifrs-full:ProfitLossBeforeTax",
      "label": "Profit (loss) before tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfProfitOrLoss",
            "field": "ifrs-full:ProfitLossBeforeTax"
          }
        ]
      }
    },
    {
      "qname": "ssmt-mfrs:AggregateProfitLossBeforeTax",
      "required": true,
      "label": "Total profit (loss) before tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= ProfitLossBeforeTax",
        "dependencies": ["ifrs-full:ProfitLossBeforeTax"]
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsToReconcileProfitLossHeader",
      "label": "Adjustments to reconcile profit (loss)",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForDepreciationExpense",
      "label": "Adjustments for depreciation",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForAmortisationExpense",
      "label": "Adjustments for amortisation expense",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForDividendIncome",
      "label": "(-) Adjustments for dividend income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForSharebasedPayments",
      "label": "Adjustments for equity settled share-based payment transactions",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForGainsLossesOnFairValueAdjustmentInvestmentProperty",
      "label": "(-) Adjustments for changes in fair value of investment properties",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:AdjustmentsForUnrealisedForeignExchangeGainLoss",
      "label": "Adjustments for unrealised foreign exchange losses (gains)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForInterestIncome",
      "label": "(-) Adjustments for interest income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:AdjustmentsForPerformanceBasedEmployeeShareSchemeAndOtherExpenses",
      "label": "Adjustments for performance based employee share scheme and other expenses",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:AdjustmentsForShareOfProfitsOfJointVentures",
      "label": "Adjustments for share of profits of joint ventures (net of tax)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:AdjustmentsForShareOptionExpenses",
      "label": "Adjustments for share option expenses",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForUndistributedProfitsOfAssociates",
      "label": "(-) Adjustments for undistributed profits of associates",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForFinanceCosts",
      "label": "Adjustments for finance costs",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForFinanceIncome",
      "label": "(-) Adjustments for finance income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:PaymentsForLeasesOfLowValueAssetsAndVariableLeasePaymentsNotIncludedInMeasurementOfLeaseLiability",
      "label": "(-) Short-term lease payments, payments for leases of low-value assets and variable lease payments not included in the measurement of the lease liability",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:AdjustmentsForOtherNoncurrentAssets",
      "label": "Adjustments for other non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForImpairmentLossReversalOfImpairmentLossRecognisedInProfitOrLossHeader",
      "label": "Adjustments for impairment loss (reversal of impairment loss) recognised in profit or loss",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-full:ImpairmentLossRecognisedInProfitOrLossPropertyPlantAndEquipment",
      "label": "Impairment (reversal of impairment) of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ImpairmentLossRecognisedInProfitOrLossInvestmentProperty",
      "label": "Impairment (reversal of impairment) of investment properties",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:ImpairmentLossRecognisedInProfitOrLossOfPrepaidLeaseRental",
      "label": "Impairment (reversal of impairment) of prepaid lease rentals",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ImpairmentLossRecognisedInProfitOrLossIntangibleAssetsOtherThanGoodwill",
      "label": "Impairment (reversal of impairment) of intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:ImpairmentLossRecognisedInProfitOrLossOfInvestmentInSubsidiaries",
      "label": "Impairment (reversal of impairment) of investment in subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:ImpairmentLossRecognisedInProfitOrLossOfInvestmentsInAssociates",
      "label": "Impairment (reversal of impairment) of investment in associates",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:ImpairmentLossRecognisedInProfitOrLossOfInvestmentsInJointVentures",
      "label": "Impairment (reversal of impairment) of investment in joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:ImpairmentLossRecognisedInProfitOrLossOnOtherInvestments",
      "label": "Impairment (reversal of impairment) of other investments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:ImpairmentLossRecognisedInProfitOrLossOnOtherFinancialAssetsOrReceivables",
      "label": "Impairment (reversal of impairment) of other financial assets or receivables",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ImpairmentLossRecognisedInProfitOrLoss",
      "label": "Total adjustment for impairment (reversal of impairment)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= PPE + InvProperties + PrepaidLeaseRentals + IntangibleAssets + Subsidiaries + Associates + JointVentures + OtherInvestments + OtherFinancialAssets",
        "dependencies": [
          "ifrs-full:ImpairmentLossRecognisedInProfitOrLossPropertyPlantAndEquipment",
          "ifrs-full:ImpairmentLossRecognisedInProfitOrLossInvestmentProperty",
          "ssmt-mfrs:ImpairmentLossRecognisedInProfitOrLossOfPrepaidLeaseRental",
          "ifrs-full:ImpairmentLossRecognisedInProfitOrLossIntangibleAssetsOtherThanGoodwill",
          "ssmt-mfrs:ImpairmentLossRecognisedInProfitOrLossOfInvestmentInSubsidiaries",
          "ssmt-mfrs:ImpairmentLossRecognisedInProfitOrLossOfInvestmentsInAssociates",
          "ssmt-mfrs:ImpairmentLossRecognisedInProfitOrLossOfInvestmentsInJointVentures",
          "ssmt-mfrs:ImpairmentLossRecognisedInProfitOrLossOnOtherInvestments",
          "ssmt-mfrs:ImpairmentLossRecognisedInProfitOrLossOnOtherFinancialAssetsOrReceivables"
        ]
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForLossesGainsOnDisposalOfNoncurrentAssetsHeader",
      "label": "Adjustments for losses (gains) on disposal of non-current assets",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-full:GainsLossesOnDisposalsOfPropertyPlantAndEquipment",
      "label": "(Gain) loss on disposal of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:GainsLossesOnDisposalsOfInvestmentProperties",
      "label": "(Gain) loss on disposal of investment properties",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:GainsLossesOnDisposalsOfNoncurrentAssets",
      "label": "(-) Total gain (loss) on disposal of non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= DisposalPPE + DisposalInvestmentProperties",
        "dependencies": [
          "ifrs-full:GainsLossesOnDisposalsOfPropertyPlantAndEquipment",
          "ifrs-full:GainsLossesOnDisposalsOfInvestmentProperties"
        ]
      }
    },
    {
      "qname": "ssmt-mfrs:GainsLossesOnDisposalOfSubsidiaries",
      "label": "(-) (Gain) loss on disposal of subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:GainsLossesOnDisposalOfAssociates",
      "label": "(-) (Gain) loss on disposal of associates",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:GainsLossesOnDisposalOfJointVentures",
      "label": "(-) (Gain) loss on disposal of joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:GainsLossesOnDisposalOfOtherInvestments",
      "label": "(-) Gain on disposal of other investments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:RealisedGainTransferredFromEquityOnForeignCurrencyExchange",
      "label": "(-) Realised foreign currencies exchange gain transferred from equity",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherAdjustmentsForNoncashItems",
      "label": "Other adjustments for non-cash items",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:WriteoffHeader",
      "label": "Write-off:",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-full:WritedownsReversalsOfPropertyPlantAndEquipment",
      "label": "Write offs of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:WritedownsReversalsOfIntangibleAssets",
      "label": "Write offs of intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:WritedownsReversalsOfInvestments",
      "label": "Write offs of investments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:WritedownsReversalsOfInventories",
      "label": "Write offs of inventories",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:WritedownsOfTradeAndOtherReceivables",
      "label": "Write off of trade and other receivables",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:WritedownsReversalsOfOtherFinancialAssets",
      "label": "Write offs of other financial assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:WritedownsReversalsOfAssets",
      "label": "Total write-off",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= PPE + Intangible + Investments + Inventories + TradeReceivables + OtherFinancial",
        "dependencies": [
          "ifrs-full:WritedownsReversalsOfPropertyPlantAndEquipment",
          "ssmt-mfrs:WritedownsReversalsOfIntangibleAssets",
          "ssmt-mfrs:WritedownsReversalsOfInvestments",
          "ifrs-full:WritedownsReversalsOfInventories",
          "ssmt-mfrs:WritedownsOfTradeAndOtherReceivables",
          "ssmt-mfrs:WritedownsReversalsOfOtherFinancialAssets"
        ]
      }
    },
    {
      "qname": "ssmt-mfrs:WriteBackOfExpenses",
      "label": "Write back of expenses",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherAdjustmentsToReconcileProfitLoss",
      "label": "Other adjustments to reconcile profit (loss)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForReconcileProfitLoss",
      "required": true,
      "label": "Total adjustments to reconcile profit (loss)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= (Depreciation + Amortisation + SharebasedPayments + UnrealisedForeignExchange + PerformanceBasedEmployeeShareScheme + ShareOfProfitsOfJointVentures + ShareOptionExpenses + FinanceCosts + OtherNoncurrentAssets + TotalImpairment + OtherNoncashItems + TotalWriteoff + WriteBackOfExpenses + OtherAdjustmentsToReconcileProfitLoss) - (DividendIncome + FairValueAdjustmentInvestmentProperty + InterestIncome + UndistributedProfitsOfAssociates + FinanceIncome + LowValueLeasePayments + TotalGainsLossesOnDisposalOfNoncurrentAssets + DisposalOfSubsidiaries + DisposalOfAssociates + DisposalOfJointVentures + DisposalOfOtherInvestments + RealisedForeignCurrencyExchangeGain)",
        "dependencies": [
          "ifrs-full:AdjustmentsForDepreciationExpense",
          "ifrs-full:AdjustmentsForAmortisationExpense",
          "ifrs-full:AdjustmentsForDividendIncome",
          "ifrs-full:AdjustmentsForSharebasedPayments",
          "ifrs-full:AdjustmentsForGainsLossesOnFairValueAdjustmentInvestmentProperty",
          "ssmt-mfrs:AdjustmentsForUnrealisedForeignExchangeGainLoss",
          "ifrs-full:AdjustmentsForInterestIncome",
          "ssmt-mfrs:AdjustmentsForPerformanceBasedEmployeeShareSchemeAndOtherExpenses",
          "ssmt-mfrs:AdjustmentsForShareOfProfitsOfJointVentures",
          "ssmt-mfrs:AdjustmentsForShareOptionExpenses",
          "ifrs-full:AdjustmentsForUndistributedProfitsOfAssociates",
          "ifrs-full:AdjustmentsForFinanceCosts",
          "ifrs-full:AdjustmentsForFinanceIncome",
          "ssmt-mfrs:PaymentsForLeasesOfLowValueAssetsAndVariableLeasePaymentsNotIncludedInMeasurementOfLeaseLiability",
          "ssmt-mfrs:AdjustmentsForOtherNoncurrentAssets",
          "ifrs-full:ImpairmentLossRecognisedInProfitOrLoss",
          "ifrs-full:GainsLossesOnDisposalsOfNoncurrentAssets",
          "ssmt-mfrs:GainsLossesOnDisposalOfSubsidiaries",
          "ssmt-mfrs:GainsLossesOnDisposalOfAssociates",
          "ssmt-mfrs:GainsLossesOnDisposalOfJointVentures",
          "ssmt-mfrs:GainsLossesOnDisposalOfOtherInvestments",
          "ssmt-mfrs:RealisedGainTransferredFromEquityOnForeignCurrencyExchange",
          "ifrs-full:OtherAdjustmentsForNoncashItems",
          "ssmt-mfrs:WritedownsReversalsOfAssets",
          "ssmt-mfrs:WriteBackOfExpenses",
          "ifrs-full:OtherAdjustmentsToReconcileProfitLoss"
        ]
      }
    },
    {
      "qname": "ifrs-full:CashFlowsFromUsedInOperationsBeforeChangesInWorkingCapital",
      "required": true,
      "label": "Operating surplus (deficit) before working capital changes",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= TotalProfitLossBeforeTax + TotalAdjustmentsToReconcileProfitLoss",
        "dependencies": [
          "ssmt-mfrs:AggregateProfitLossBeforeTax",
          "ifrs-full:AdjustmentsForReconcileProfitLoss"
        ]
      }
    },
    {
      "qname": "ifrs-full:ChangesInWorkingCapitalHeader",
      "label": "Changes in working capital",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForDecreaseIncreaseInInventories",
      "label": "(-) Adjustments for decrease (increase) in inventories",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForDecreaseIncreaseInTradeAndOtherReceivables",
      "label": "(-) Adjustments for decrease (increase) in trade and other receivables",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForIncreaseDecreaseInTradeAndOtherPayables",
      "label": "(-) Adjustments for increase (decrease) in trade and other payables",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:AdjustmentsForDecreaseIncreaseInPropertyDevelopmentCosts",
      "label": "(-) Adjustments for decrease (increase) in property development costs",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AdjustmentsForDecreaseIncreaseInContractAssets",
      "label": "(-) Adjustments for decrease (increase) in contract assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt:AdjustmentsForDecreaseIncreaseInContractLiabilities",
      "label": "(-) Adjustments for decrease (increase) in contract liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:IncreaseDecreaseInWorkingCapital",
      "required": true,
      "label": "Total changes in working capital",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "note": "Sum of working capital adjustments (negative sum section)"
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= -(Inventories + TradeReceivables + TradePayables + PropertyDevCosts + ContractAssets + ContractLiabilities)",
        "dependencies": [
          "ifrs-full:AdjustmentsForDecreaseIncreaseInInventories",
          "ifrs-full:AdjustmentsForDecreaseIncreaseInTradeAndOtherReceivables",
          "ifrs-full:AdjustmentsForIncreaseDecreaseInTradeAndOtherPayables",
          "ssmt-mfrs:AdjustmentsForDecreaseIncreaseInPropertyDevelopmentCosts",
          "ifrs-full:AdjustmentsForDecreaseIncreaseInContractAssets",
          "ssmt:AdjustmentsForDecreaseIncreaseInContractLiabilities"
        ]
      }
    },
    {
      "qname": "ifrs-full:CashFlowsFromUsedInOperations",
      "required": true,
      "label": "Cash generated from (used in) operations",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= OperatingSurplusDeficit + TotalChangesInWorkingCapital",
        "dependencies": [
          "ifrs-full:CashFlowsFromUsedInOperationsBeforeChangesInWorkingCapital",
          "ifrs-full:IncreaseDecreaseInWorkingCapital"
        ]
      }
    },
    {
      "qname": "ifrs-full:DividendsReceivedClassifiedAsOperatingActivities",
      "label": "Dividends received",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:DividendsPaidClassifiedAsOperatingActivities",
      "label": "Dividends paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:InterestReceivedClassifiedAsOperatingActivities",
      "label": "Interest received",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:InterestPaidClassifiedAsOperatingActivities",
      "label": "Interest paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:PaymentsForRetirementBenefitsScheme",
      "label": "Payment to a retirement benefits scheme",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:IncomeTaxesPaidRefundClassifiedAsOperatingActivities",
      "label": "Income taxes refund (paid)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherInflowsOutflowsOfCashClassifiedAsOperatingActivities",
      "label": "Other cash inflows (outflows) from operating activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:CashFlowsFromUsedInOperatingActivities",
      "required": true,
      "label": "Net cash flows from (used in) operating activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= CashGeneratedFromOperations + DividendsReceived + DividendsPaid + InterestReceived + InterestPaid + RetirementPayment + IncomeTaxes + OtherCashFlows",
        "dependencies": [
          "ifrs-full:CashFlowsFromUsedInOperations",
          "ifrs-full:DividendsReceivedClassifiedAsOperatingActivities",
          "ifrs-full:DividendsPaidClassifiedAsOperatingActivities",
          "ifrs-full:InterestReceivedClassifiedAsOperatingActivities",
          "ifrs-full:InterestPaidClassifiedAsOperatingActivities",
          "ssmt-mfrs:PaymentsForRetirementBenefitsScheme",
          "ifrs-full:IncomeTaxesPaidRefundClassifiedAsOperatingActivities",
          "ifrs-full:OtherInflowsOutflowsOfCashClassifiedAsOperatingActivities"
        ]
      }
    },
    {
      "qname": "ifrs-full:CashFlowsFromUsedInInvestingActivitiesHeader",
      "label": "Cash flows from (used in) investing activities",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ifrs-full:CashFlowsFromLosingControlOfSubsidiariesOrOtherBusinessesClassifiedAsInvestingActivities",
      "label": "Proceeds from disposal of subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:CashFlowsUsedInObtainingControlOfSubsidiariesOrOtherBusinessesClassifiedAsInvestingActivities",
      "label": "(-) Acquisition and subscription of shares in subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ProceedsFromSalesOfInterestsInAssociates",
      "label": "Proceeds from disposal of associates",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCashPaymentsToAcquireInterestsInAssociates",
      "label": "Acquisition and subscription of shares in associates",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherCashReceiptsFromSalesOfInterestsInJointVenturesClassifiedAsInvestingActivities",
      "label": "Proceeds from disposal of joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherCashPaymentsToAcquireInterestsInJointVenturesClassifiedAsInvestingActivities",
      "label": "(-) Acquisition and subscription of shares in joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:CashReceiptsFromRepaymentOfAdvancesAndLoansMadeToOtherPartiesClassifiedAsInvestingActivities",
      "label": "Cash receipts from repayment of advances and loans made to other parties, classified as investing activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:CashAdvancesAndLoansMadeToOtherPartiesClassifiedAsInvestingActivities",
      "label": "(-) Cash advances and loans made to other parties",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:DepositPlacedWithInvestmentBrokers",
      "label": "Deposit placed with investment brokers",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherCashPaymentsToAcquireEquityOrDebtInstrumentsOfOtherEntitiesClassifiedAsInvestingActivities",
      "label": "(-) Other cash payments to acquire equity or debt instruments of other entities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherCashReceiptsFromSalesOfEquityOrDebtInstrumentsOfOtherEntitiesClassifiedAsInvestingActivities",
      "label": "Other cash receipts from sales of equity or debt instruments of other entities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:ProceedsFromDisposalOfNetCashAndCashEqivalentsDisposedOffFromDiscontinuingOperatrions",
      "label": "(-) Disposal of discontinued operation, proceeds from disposal, net of cash and cash equivalents disposed of",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:TaxPaidOnGainOnDisposalFromDiscontinuingOperations",
      "label": "Disposal of discontinued operation, tax paid on gain on disposal",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ProceedsFromGovernmentGrantsClassifiedAsInvestingActivities",
      "label": "Proceeds from government grants",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ProceedsFromSalesOfIntangibleAssetsClassifiedAsInvestingActivities",
      "label": "Proceeds from sales of intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ProceedsFromOtherLongtermAssetsClassifiedAsInvestingActivities",
      "label": "Proceeds from sales of other non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ProceedsFromSalesOfPropertyPlantAndEquipmentClassifiedAsInvestingActivities",
      "label": "Proceeds from sales of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:ProceedsFromSaleOfPrepaidLeasePayments",
      "label": "Proceeds from sale of prepaid lease payments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:PurchaseOfIntangibleAssetsClassifiedAsInvestingActivities",
      "label": "(-) Purchase of intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:PurchaseOfOtherLongtermAssetsClassifiedAsInvestingActivities",
      "label": "(-) Purchase of other non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:PurchaseOfPropertyPlantAndEquipmentClassifiedAsInvestingActivities",
      "label": "(-) Purchase of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:DividendsReceivedClassifiedAsInvestingActivities",
      "label": "Dividends received",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:InterestReceivedClassifiedAsInvestingActivities",
      "label": "Interest received",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ProceedsFromSalesOfInvestmentsOtherThanInvestmentsAccountedForUsingEquityMethod",
      "label": "Proceeds from sale of other investment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:PurchaseOfInvestmentsOtherThanInvestmentsAccountedForUsingEquityMethod",
      "label": "(-) Purchase of other investment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:PaymentsForDevelopmentProjectExpenditure",
      "label": "(-) Development expenditure incurred",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:NetRepaymentFromJointVentures",
      "label": "(-) Net repayment from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:NetRepaymentFromAssociates",
      "label": "(-) Net repayment from associates",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:CapitalDistributionsFromAssociates",
      "label": "Capital distributions from associates",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherInflowsOutflowsOfCashClassifiedAsInvestingActivities",
      "label": "Other cash inflows (outflows) from investing activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:CashFlowsFromUsedInInvestingActivities",
      "required": true,
      "label": "Net cash flows from (used in) investing activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= Sum of all 30 investing activity fields",
        "dependencies": [
          "ifrs-full:CashFlowsFromLosingControlOfSubsidiariesOrOtherBusinessesClassifiedAsInvestingActivities",
          "ifrs-full:CashFlowsUsedInObtainingControlOfSubsidiariesOrOtherBusinessesClassifiedAsInvestingActivities",
          "ifrs-full:ProceedsFromSalesOfInterestsInAssociates",
          "ssmt-mfrs:OtherCashPaymentsToAcquireInterestsInAssociates",
          "ifrs-full:OtherCashReceiptsFromSalesOfInterestsInJointVenturesClassifiedAsInvestingActivities",
          "ifrs-full:OtherCashPaymentsToAcquireInterestsInJointVenturesClassifiedAsInvestingActivities",
          "ifrs-full:CashReceiptsFromRepaymentOfAdvancesAndLoansMadeToOtherPartiesClassifiedAsInvestingActivities",
          "ifrs-full:CashAdvancesAndLoansMadeToOtherPartiesClassifiedAsInvestingActivities",
          "ssmt-mfrs:DepositPlacedWithInvestmentBrokers",
          "ifrs-full:OtherCashPaymentsToAcquireEquityOrDebtInstrumentsOfOtherEntitiesClassifiedAsInvestingActivities",
          "ifrs-full:OtherCashReceiptsFromSalesOfEquityOrDebtInstrumentsOfOtherEntitiesClassifiedAsInvestingActivities",
          "ssmt-mfrs:ProceedsFromDisposalOfNetCashAndCashEqivalentsDisposedOffFromDiscontinuingOperatrions",
          "ssmt-mfrs:TaxPaidOnGainOnDisposalFromDiscontinuingOperations",
          "ifrs-full:ProceedsFromGovernmentGrantsClassifiedAsInvestingActivities",
          "ifrs-full:ProceedsFromSalesOfIntangibleAssetsClassifiedAsInvestingActivities",
          "ifrs-full:ProceedsFromOtherLongtermAssetsClassifiedAsInvestingActivities",
          "ifrs-full:ProceedsFromSalesOfPropertyPlantAndEquipmentClassifiedAsInvestingActivities",
          "ssmt-mfrs:ProceedsFromSaleOfPrepaidLeasePayments",
          "ifrs-full:PurchaseOfIntangibleAssetsClassifiedAsInvestingActivities",
          "ifrs-full:PurchaseOfOtherLongtermAssetsClassifiedAsInvestingActivities",
          "ifrs-full:PurchaseOfPropertyPlantAndEquipmentClassifiedAsInvestingActivities",
          "ifrs-full:DividendsReceivedClassifiedAsInvestingActivities",
          "ifrs-full:InterestReceivedClassifiedAsInvestingActivities",
          "ifrs-full:ProceedsFromSalesOfInvestmentsOtherThanInvestmentsAccountedForUsingEquityMethod",
          "ifrs-full:PurchaseOfInvestmentsOtherThanInvestmentsAccountedForUsingEquityMethod",
          "ifrs-full:PaymentsForDevelopmentProjectExpenditure",
          "ssmt-mfrs:NetRepaymentFromJointVentures",
          "ssmt-mfrs:NetRepaymentFromAssociates",
          "ssmt-mfrs:CapitalDistributionsFromAssociates",
          "ifrs-full:OtherInflowsOutflowsOfCashClassifiedAsInvestingActivities"
        ]
      }
    },
    {
      "qname": "ifrs-full:CashFlowsFromUsedInFinancingActivitiesHeader",
      "label": "Cash flows from (used in) financing activities",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ssmt-mfrs:PaymentsForPrincipalPortionOfLeaseLiability",
      "label": "Cash payments for the principal portion of the lease liability",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:PaymentsForInterestPortionOfLeaseLiability",
      "label": "Cash payments for the interest portion of the lease liability",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ProceedsFromIssuingShares",
      "label": "Proceeds from issuing shares",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:ProceedsFromIssueOfSharesInSubsidiaryToNoncontrollingInterests",
      "label": "Proceeds from issue of shares in subsidiary to non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ProceedsFromIssuingOtherEquityInstruments",
      "label": "Proceeds from issuing other equity instruments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ProceedsFromExerciseOfOptions",
      "label": "Proceeds from share-based compensation transactions",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:PaymentsToAcquireOrRedeemEntitysShares",
      "label": "(-) Payments to acquire or redeem entity's shares",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:PaymentsMadeToAcquireNoncontrollingInterest",
      "label": "(-) Acquisition of non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:PaymentsOfOtherEquityInstruments",
      "label": "(-) Payments of other equity instruments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:CashPaymentsForIssuanceOfPerpetualSukuk",
      "label": "Perpetual sukuk issuance expenses",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ProceedsFromIssueOfBondsNotesAndDebentures",
      "label": "Proceeds from issuing debentures, loans, notes, bonds, mortgages and other short-term and long-term borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:RepaymentsOfBorrowingsClassifiedAsFinancingActivities",
      "label": "(-) Repayments of borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:RepurchaseOfTreasuryShares",
      "label": "Repurchase of treasury shares",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:WithdrawalOfBankDeposits",
      "label": "Withdrawal(Placement) of bank deposits",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:WithdrawalOfSecuritiesPledgedForBorrowings",
      "label": "Withdrawal(Placement) of securities pledged for borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:DividendsPaidClassifiedAsFinancingActivities",
      "label": "(-) Dividends paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:InterestPaidClassifiedAsFinancingActivities",
      "label": "(-) Interest paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherInflowsOutflowsOfCashClassifiedAsFinancingActivities",
      "label": "Other cash inflows (outflows) from financing activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:CashFlowsFromUsedInFinancingActivities",
      "required": true,
      "label": "Net cash flows from (used in) financing activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= Sum of all 18 financing activity fields",
        "dependencies": [
          "ssmt-mfrs:PaymentsForPrincipalPortionOfLeaseLiability",
          "ssmt-mfrs:PaymentsForInterestPortionOfLeaseLiability",
          "ifrs-full:ProceedsFromIssuingShares",
          "ssmt-mfrs:ProceedsFromIssueOfSharesInSubsidiaryToNoncontrollingInterests",
          "ifrs-full:ProceedsFromIssuingOtherEquityInstruments",
          "ifrs-full:ProceedsFromExerciseOfOptions",
          "ifrs-full:PaymentsToAcquireOrRedeemEntitysShares",
          "ssmt-mfrs:PaymentsMadeToAcquireNoncontrollingInterest",
          "ifrs-full:PaymentsOfOtherEquityInstruments",
          "ssmt-mfrs:CashPaymentsForIssuanceOfPerpetualSukuk",
          "ifrs-full:ProceedsFromIssueOfBondsNotesAndDebentures",
          "ifrs-full:RepaymentsOfBorrowingsClassifiedAsFinancingActivities",
          "ssmt-mfrs:RepurchaseOfTreasuryShares",
          "ssmt-mfrs:WithdrawalOfBankDeposits",
          "ssmt-mfrs:WithdrawalOfSecuritiesPledgedForBorrowings",
          "ifrs-full:DividendsPaidClassifiedAsFinancingActivities",
          "ifrs-full:InterestPaidClassifiedAsFinancingActivities",
          "ifrs-full:OtherInflowsOutflowsOfCashClassifiedAsFinancingActivities"
        ]
      }
    },
    {
      "qname": "ifrs-full:IncreaseDecreaseInCashAndCashEquivalentsBeforeEffectOfExchangeRateChanges",
      "required": true,
      "label": "Net increase (decrease) in cash and cash equivalents before effect of exchange rate changes",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= NetCashFlowsFromOperatingActivities + NetCashFlowsFromInvestingActivities + NetCashFlowsFromFinancingActivities",
        "dependencies": [
          "ifrs-full:CashFlowsFromUsedInOperatingActivities",
          "ifrs-full:CashFlowsFromUsedInInvestingActivities",
          "ifrs-full:CashFlowsFromUsedInFinancingActivities"
        ]
      }
    },
    {
      "qname": "ifrs-full:EffectOfExchangeRateChangesOnCashAndCashEquivalents",
      "label": "Effect of exchange rate changes on cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:IncreaseDecreaseInCashAndCashEquivalents",
      "required": true,
      "label": "Net increase (decrease) in cash and cash equivalents after effect of exchange rate changes",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= NetIncreaseDecreaseBeforeExchangeRate + EffectOfExchangeRate",
        "dependencies": [
          "ifrs-full:IncreaseDecreaseInCashAndCashEquivalentsBeforeEffectOfExchangeRateChanges",
          "ifrs-full:EffectOfExchangeRateChangesOnCashAndCashEquivalents"
        ]
      }
    },
    {
      "qname": "ifrs-full:CashAndCashEquivalents:Beginning",
      "label": "Cash and cash equivalents at beginning of period",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal",
        "consecutiveYearCash": {
          "comparisons": [
            {
              "beginningConsolidationType": "Consolidated",
              "compareField": "ifrs-full:CashAndCashEquivalents:End"
            },
            {
              "beginningConsolidationType": "Consolidated",
              "compareField": "ifrs-full:CashAndCashEquivalents:End_occurrence2"
            },
            {
              "beginningConsolidationType": "Separate",
              "compareField": "ifrs-full:CashAndCashEquivalents:End"
            },
            {
              "beginningConsolidationType": "Separate",
              "compareField": "ifrs-full:CashAndCashEquivalents:End_occurrence2"
            }
          ],
          "sheet": "statementOfCashFlowsIndirectMethod"
        }
      }
    },
    {
      "qname": "ifrs-full:CashAndCashEquivalents:End",
      "label": "Cash and cash equivalents at end of period",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfCashFlowsIndirectMethod",
            "field": "ifrs-full:CashAndCashEquivalents:End_occurrence2",
            "skipIfSourceNull": true,
            "message": "Mismatch in value provided for the same field. The value should match Cash and cash equivalents at end of period (under section Details of cash flows) in Statement of Cash Flows (Indirect Method)."
          }
        ]
      }
    },
    {
      "qname": "ssmt-mfrs:DetailsOfCashFlowsHeader",
      "label": "Details of cash flows",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt:CashAndBankBalances",
      "label": "Cash and bank balances",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfFinancialPosition",
            "field": "ssmt:CashAndBankBalances"
          }
        ]
      }
    },
    {
      "qname": "ifrs-full:BankOverdraftsClassifiedAsCashEquivalents",
      "label": "(-) Bank overdraft",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt:OtherAdjustmentsToReconcileCashAndCashEquivalents",
      "label": "Other adjustments to reconcile cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:CashAndCashEquivalents:End_occurrence2",
      "required": true,
      "label": "Cash and cash equivalents at end of period",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfCashFlowsIndirectMethod",
            "field": "ifrs-full:CashAndCashEquivalents:End",
            "skipIfTargetNull": true,
            "message": "Mismatch in value provided for the same field. The value should match Cash and cash equivalents at end of period (under section Cash flows from (used in) financing activities) in Statement of Cash Flows (Indirect Method)."
          }
        ]
      },
      "calculation": {
        "formula": "= CashAndBankBalances - BankOverdraft + OtherAdjustments",
        "dependencies": [
          "ssmt:CashAndBankBalances",
          "ifrs-full:BankOverdraftsClassifiedAsCashEquivalents",
          "ssmt:OtherAdjustmentsToReconcileCashAndCashEquivalents"
        ]
      }
    }
  ]
}
